module.exports = __webpack_public_path__ + "img/1_5.773c8f9e.jpg";